import get from 'lodash/get';
import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getCompaniesModel = createSelector(
    getModel,
    (model) => model.companies,
);

export const getCompaniesData = createSelector(getCompaniesModel, (model) =>
    !model.data.data
        ? []
        : model.data.data.map((company) => ({
              active_users: company.active_users,
              billing: company.billing,
              business_name: company.name,
              contact_telephone: company.contact_telephone,
              country: get(company, 'country.name', ''),
              created_at: company.created_at,
              id: company.id,
              owner_email: company.owner_email,
              owner_fullname: company.owner_fullname,
              plan_name: company.plan_name,
              position_city: company.position_city,
          })),
);

export const getCompaniesErrors = createSelector(
    getCompaniesModel,
    (model) => model.errors,
);

export const getCompaniesIsFetching = createSelector(
    getCompaniesModel,
    (model) => model.isFetching,
);

export const getCompaniesPagination = createSelector(
    getCompaniesModel,
    (model) => model.data.pagination || {},
);

export const getCompaniesCSV = createSelector(
    getModel,
    (model) => model.downloadCSV,
);

export const getIsFetchingCompaniesCSV = createSelector(
    getCompaniesCSV,
    (downloadCSV) => downloadCSV.isFetching,
);

export const getCountries = createSelector(
    getModel,
    (model) => model.countries,
);

export const getContriesData = createSelector(
    getCountries,
    (model) => model.data,
);

export const getIsFetchingCountries = createSelector(
    getCountries,
    (model) => model.isFetching,
);
